// src/features/aws/getAWSDBLogsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpInterceptor from "../../common/APIConfig";

// Async thunk for fetching AWS VM Logs
export const getAWSDBLogs = createAsyncThunk(
  "AWSDBLogs/fetch",
  async ({ accountId, instanceId, tag }, { rejectWithValue }) => {
    try {
      const response = await httpInterceptor.get(
        `/resources/aws/rds-logs?account=${accountId}&database=${instanceId}&tag=${tag}`,
        {
          // params: { account: accountId, instance: instanceId, tag }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching AWS VM logs"
      );
    }
  }
);

const getAWSDBLogsSlice = createSlice({
  name: "AWSDBLogs",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetAWSDBLogs: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAWSDBLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAWSDBLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAWSDBLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetAWSDBLogs } = getAWSDBLogsSlice.actions;

export default getAWSDBLogsSlice.reducer;
